import { useDocumentTitle } from '@/hooks';
import { Stack } from '@mui/material';
import { OptionsTable } from './OptionsTable';

export function TelematicsBoxOptions() {
  useDocumentTitle('IR3 | Telematics Box Options');

  return (
    <Stack direction="row" spacing={1} sx={{ p: 1 }}>
      <OptionsTable name="telematicsBoxType" title="Types" />
    </Stack>
  );
}
